var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import getOrganisationAssets from '../../requests/asset/getOrganisationAssets';
import Signals from '../../signals/Signals';
/**
 *
 */
var GetOrganisationAssetsCommand = /** @class */ (function (_super) {
    __extends(GetOrganisationAssetsCommand, _super);
    function GetOrganisationAssetsCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param organisation OrganisationModel
     * @param assetCollection AssetCollection
     * @return {Promise<T | never>}
     */
    GetOrganisationAssetsCommand.prototype.execute = function (organisation, assetCollection) {
        this.organisation = organisation;
        this.assetCollection = assetCollection;
        if (this.assetCollection.fetching) {
            return this.assetCollection.fetching;
        }
        else {
            this.assetCollection.fetching = getOrganisationAssets(organisation.id, !this.assetCollection.firstFetchComplete).then(this.then).catch(this.catch);
            return this.assetCollection.fetching;
        }
    };
    /**
     *
     * @param response
     */
    GetOrganisationAssetsCommand.prototype.then = function (response) {
        this.assetCollection.fetching = null;
        if (!this.assetCollection.firstFetchComplete) {
            this.assetCollection.firstFetchComplete = true;
        }
        this.assetCollection.reset(false);
        this.assetCollection.addAll(response.features);
        Signals.AssetsRetrieved.dispatch();
    };
    /**
     *
     * @param error
     */
    GetOrganisationAssetsCommand.prototype.catch = function (error) {
        this.assetCollection.fetching = null;
        throw error;
    };
    return GetOrganisationAssetsCommand;
}(Command));
export default GetOrganisationAssetsCommand;
